import React from 'react';
import { Table, Empty, Button, Input, Form, Tooltip,Select } from 'antd';
import { GREATER_THAN_ZERO } from '../../../common/types/regularExpresionType';
const { Option } = Select;
export default function DetalleProductoServicioModal(props) {
    return (
        <div>
            <Table
                className={'table-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.idProducto}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 40,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row.idProducto)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Insumo',
                        dataIndex: 'idProducto',
                        key: 'idProducto',
                        render: (value, row) => {
                            return (
                                <Form.Item >
                                    {props.onGetFieldDecorator(`arridProducto[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,                                   
                                    })(
                                       <span>{row.nombre}</span>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Unidad de Medida',
                        dataIndex: 'idUnidadMedida',
                        key: 'idUnidadMedida',
                        render: (value, row,index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arridUnidadMedida[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onChange'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo Comprobante"}
                                            optionFilterProp="children"
                                            onChange={(option) => {props.onChange("arridUnidadMedida", option.key, row,index );}}
                                        >
                                            {props.unidadMedida.map(item => (
                                                row.idProducto==item.idProducto?
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>:null
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'center',
                        width: 90,
                        render: (value, row,index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrCantidad[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(0),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Formato (0)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Cantidad"
                                            autoComplete="off"
                                            className="text-right"
                                           onBlur={(e) => props.onChange("arrCantidad", e.target.value, row,index)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    
                ]}
            />
        </div>
    );
}